module.exports = __webpack_public_path__ + "static/media/icon-instagram.57e98c46.svg";